export default __webpack_public_path__ + "static/orbital-scrubberx150-26c09b3e081cbeb8952772ce5f458a2c.png";